
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { Getter, Action } from 's-vuex-class'
import AppTileCarousel from './AppTileCarousel.vue'
import { saveLaunchPadConfig } from '@/api/appstore'
import { notifySuccess, notifyError } from '@/utils/appstore'
import { App } from '@/pages/appstore/entities/app'

@Component<LaunchPadApps>({
    components: {
        AppTileCarousel,
        Loading: () => import('@/components/Loading.vue'),
    },
})
export default class LaunchPadApps extends Vue {
    public hasBeenDismissed = false

    @Prop({ type: Boolean, required: false })
    public readonly loading?: boolean
    @Prop({ type: Boolean, required: false })
    public readonly inAppstore?: boolean

    @Getter public getLaunchPadApps
    @Getter public getAllApps
    @Getter public isShowLaunchPad
    @Getter public getInstalledAppsNames
    @Action public setShowLaunchPad

    public get getIntegrationNames() {
        return this.getLaunchPadApps.map((e: App) => e.title).join(', ')
    }

    public get hasContent(): boolean {
        return (
            (!this.hasBeenDismissed && this.getAllApps.length > 0) ||
            !!this.loading
        )
    }

    public redirectToIntegration() {
        if (!this.inAppstore) {
            window.location.href = `${window.location.origin}/appstore/integrate`
        } else {
            this.$router.push('/appstore/integrate')
        }
    }

    public async dismissRecommendedApps() {
        const currentTime = Math.floor(Date.now() / 1000)
        const response = await saveLaunchPadConfig({
            lastDismissLaunchPad: currentTime,
        })

        if (response.success) {
            notifySuccess('Successfully dismissed it for 24 hours!')
            this.hasBeenDismissed = true
            return
        }
        notifyError('Something went wrong, please try again later.')
    }
}
